module.exports = __webpack_public_path__ + "static/media/rex-logo.d26ae097.png";